import React from "react";
import CmmsTools from "../features/cmmsTools";

export default function CmmsToolsPage() {
  return (
    <CmmsTools />
  );
}
